import { Component, AfterViewInit, OnInit, HostListener, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { WsService2 } from './services/ws/ws.service';
import { WsService } from '../utils/network/ws.service';
import { WbService, OnWBStateLimit } from './wb.service';
import { TranslateService } from 'ng2-translate';
import { RoomParserService } from './services/room/room-parser.service';
import { RoomManagerService } from './services/room/room-manager.service';
import { ChatParserService } from './services/chat/chat-parser.service';
import { HbManagerService } from './services/hb/hb-manager.service';
import { HbParserService } from './services/hb/hb-parser.service';

import { SessionManagerService } from './services/session/session-manager.service';
import { SessionParserService } from './services/session/session-parser.service';
import { UserTypeManagerService, UserType } from './services/usertype/user-type-manager.service';
import { UserTypeParserService } from './services/usertype/user-type-parser.service';
import { MediaParserService } from './services/media/media-parser.service';
import { MediaManagerService } from './services/media/media-manager.service';
import { LayoutParserService } from './services/layout/layout-parser.service';
import { LayoutManagerService } from './services/layout/layout-manager.service';
import { OnLayoutChanged, Layout } from './services/layout/layout-manager';
import { ContentParserService } from './services/content/content-parser.service';
import { RecordingParserService } from './services/recording/recording-parser.service';
import { RecordingManagerService } from './services/recording/recording-manager.service';

import { LogService } from './services/log/log.service';
import { PermissionsManagerService } from './services/permissions/permissions-manager.service';
import { PermissionsParserService } from './services/permissions/permissions-parser.service';
import { ReplayerService } from './player/replayer.service';
import { Modal } from 'ng2-modal';
import { environment } from '../../environments/environment';
import { NetworkService } from 'app/wb/player/network.service';
import { DesksService } from './desksmenu/desks.service';
import { MediaService } from './peers/media.service';
declare var $;
declare var Tour;
@Component({

  templateUrl: 'wb.component.html',
  providers: [ChatParserService, HbParserService, HbManagerService, RoomParserService, RoomManagerService,  SessionManagerService, SessionParserService,UserTypeManagerService, WsService2,UserTypeParserService,RecordingParserService, RecordingManagerService,LayoutManagerService, LayoutParserService,
    MediaManagerService, MediaParserService,  ContentParserService, ReplayerService,NetworkService,WsService,WbService,MediaService
    ,PermissionsManagerService,PermissionsParserService,DesksService, LogService
  ],
  styles: [`
  .shareScreen{
    top:10px;
    left:10px;
  background-color:gray;
    position: absolute;

    width: 100%;
    height: 100%;
    overflow: auto;
    z-index: 1000;
  }
  .toolsOverlay{
    top:0px;
    left:0px;

    position: absolute;

    width: 100%;
    height: 100%;

    z-index: 1000;
  }
  .tool-overlayed{
    position: relative; z-index:1001
  }
.peers-panel-videos-wb{
	display: inline-block;
	vertical-align: top;
}
.peers-panel-audios-wb{
display: block;
}

  `]
})
export class WBComponent implements AfterViewInit, OnInit, OnLayoutChanged, OnWBStateLimit, OnDestroy {
  constructor(
    public log: LogService,
    public roomManager: RoomManagerService, public route: ActivatedRoute,
    public hbManager: HbManagerService, public wsService: WsService2,
    public sessionManager: SessionManagerService, public userTypeManager: UserTypeManagerService,
    public mediaManager: MediaManagerService, public wbService: WbService, public layoutManagerService: LayoutManagerService,
    public recordingParser: RecordingParserService, public recordingManager: RecordingManagerService, public replayerService: ReplayerService,
    public permissionsManager: PermissionsManagerService,
  public networkService: NetworkService
  ) {


    //public wsService: WsService, public wbService: WbService, public mediaService: MediaService, public route: ActivatedRoute, public translate: TranslateService) {

    //   translate.addLangs(["en", "bg"]);
  
  }
  @ViewChild("onNoMoreStreams") onNoMoreStreamsModal: Modal;
  @ViewChild("wsLimitReached") wsLimitReached: Modal;
  @ViewChild("wbLayoutNote") wbLayoutNote: Modal;
  boards = [{ wbType: "WELCOME", pageId: 0, column: {}, history: {} }]//{wbType: "ALGEBRA", pageId:0}];
  wbStateLimitReached() {
    this.wsLimitReached.open();
  }
  canUseTools() {
    return this.recordingManager.allowRecording || this.permissionsManager.canUseTools() || this.wsService.getFromMobile();
  }

  sub: any;
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    console.log("Unload handler")

  }

  isStudent() {

    return this.userTypeManager.getType() == UserType.STUDENT
  }
  isTeacher() {
    return this.userTypeManager.getType() == UserType.TEACHER
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    console.log("before unload handler  ")
    //  this.mediaService.close()
    this.roomManager.sendBye();
    this.wsService.cleanResources();
    this.wsService.close(true);
  }

  a;
  ngOnInit() {
    //  this.boards[0] = { wbType: "WELCOME" };
    var self = this;
    this.sub = this.route.params.subscribe(params => {
      if (params['private']) {
        this.recordingManager.allowRecording = true;

      }else{//not from the recorder
       self.sessionManager.startSendingWbStates();

      }
      console.log('allow recording', this.recordingManager.allowRecording)
      let userHash;
      if (params['hash']) {
        userHash = params['hash']
        if (params['mobile']){
          self.wsService.setFromMobile(true);
        }
      } else {

        userHash = params['demoHash'];
        self.wbService.setDemo(true);
      }
      if (params['extId']) {
        this.replayerService.extId = params['extId'];
        console.log('extId', this.replayerService.extId);
        window.addEventListener('message', data => {
          console.log(data);
          if (data.data == 'success') {
            console.log('will close');
            setTimeout(function(){
             window.close();
            }, 0);
          }
        });
      }

      console.log("Got hash " + userHash)
      console.log("boards", this.sessionManager.boards)

      self.wsService.setHash(userHash)

      self.replayerService.setUserHash(userHash);
      /*if (this.recordingManager.allowRecording){
        this.networkService.post("moveoldrecordshere/"+userHash+"/", null, false).subscribe(r => {

        }, err=>{
          alert("Something is not quite right, please contact the support.")
        });

      }*/
    });
    this.wbService.registerForWbStateLimitReached(this);
    this.wbService.registerForOnNoMoreStreams(this);
  }
  onNoMoreStreams(){
    this.onNoMoreStreamsModal.open();
  }
  helpPressed(){

  }
  hidePeers(){
    return this.wsService.getFromMobile();
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
    this.wbService.unergisterFromWbStateLimitReached(this)
    this.wbService.unregisterOnresizeCallback(this);
    this.beforeUnloadHander(null);
  }
  onResize() {
    console.log("layout is ", this.layoutManagerService.getLayout())
    if (this.layoutManagerService.isVideosWb()) {
      console.log("Will resize w b component");
      //$("#peers").width($("body").width());


      var w = 230
      // $("#peerscontainer").width($("#peerscontainer").children().length*w)
    }

  }
  ngAfterViewInit() {

    console.log("after view init");
    //this.replayerService.cleanPlayers();
    this.hbManager.onReady(environment.useHb, environment.useHb);
    this.layoutManagerService.registerLayoutChangedCallback(this);
    this.wbService.registerOnResize(this);
    this.wsService.changeTitles();



    //this.watchConnected();
    //this.watchHeartbeat();
  }
  layout = Layout.VIDEOS_WB;
  layoutChanged(layout: Layout) {
    this.layout = layout;
    this.layoutManagerService.updateLayout();
    this.wbService.onResize();
    if (this.layout == Layout.AUDIO_WB || this.layout == Layout.VIDEOS_WB || this.layout == Layout.NONE ){
      if (!this.recordingManager.allowRecording&&typeof window["wbLayoutShown"] == 'undefined'){
        window["wbLayoutShown"]=true;
        if (!this.replayerService.extId && !this.wsService.getFromMobile())
        this.wbLayoutNote.open();
      }
    }
  }
  showCameraOn(){
    try{
     return this.roomManager.getPeers()[this.wsService.getMe()].media=="both";
    }catch(err){}
  }
  showCameraOff(){
    try{
     return this.roomManager.getPeers()[this.wsService.getMe()].media!="both";
    }catch(err){}
  }
  showVolumeOn(){
    try{
     return this.roomManager.getPeers()[this.wsService.getMe()].media=="audio" ||this.roomManager.getPeers()[this.wsService.getMe()].media=="both";
    }catch(err){}
  }
  showVolumeOff(){
    try{
     return this.roomManager.getPeers()[this.wsService.getMe()].media=="none";
    }catch(err){}
  }
  getLayoutMessage(){
    try{
      switch(this.roomManager.getPeers()[this.wsService.getMe()].media){
        case "audio": return (this.userTypeManager.getType() == UserType.TEACHER?"WB_LAYOUT_NOTE.AUDIO_ALL_FOR_TEACHER":"WB_LAYOUT_NOTE.AUDIO_ALL_FOR_STUDENTS" );
        case "none": return (this.userTypeManager.getType() == UserType.TEACHER? "WB_LAYOUT_NOTE.NONE_FOR_TEACHERS": "WB_LAYOUT_NOTE.NONE_FOR_STUDENTS");
        case "both": return (this.userTypeManager.getType() == UserType.TEACHER?
        "WB_LAYOUT_NOTE.VIDEO_ALL_FOR_TEACHER":"WB_LAYOUT_NOTE.VIDEO_ALL_FOR_STUDENTS" );

      }
    }catch(err){}
  }
  hasBeenConnected() {
    return this.wsService.hasBeenConnected();
  }
  showChat(){
    return  !this.replayerService.extId&&((!this.hasBeenConnected() || this.wbService.showChat()) && !this.wsService.getFromMobile() && !this.recordingManager.allowRecording);
  }
  isConnected() {
    return this.wsService.isConnected();
  }
  shouldShowDesks() {
    return this.userTypeManager.getType() == UserType.TEACHER;
  }
  newPage(board) {
    console.log("Will try to create page from ", board);
    this.sessionManager.getCurrentStates(false);
    this.sessionManager.createPage(board.column, board.boardId, board.wbType, false)
  }
	openFooter() {
		$("footer").toggleClass("open");
  }

  startTour(){
    
  }

}



// WEBPACK FOOTER //
// /app/src/app/wb/wb.component.ts